import React, { SyntheticEvent, useState } from 'react';
import axios from 'axios';
import { redirect, useNavigate } from 'react-router-dom';

export const Login = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
    });
    const [errorMessage, setErrorMessage] = useState('');

    const onChange = (e: any) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value,
        });
    };

    const navigate = useNavigate();

    const submitHandler = async (e: SyntheticEvent) => {
        e.preventDefault();
        try {
            const tokenResponse = await axios.post('/api/login_check', credentials, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (tokenResponse.status !== 200) {
                navigate('/login');
                return;
            }

            localStorage.setItem('bearer', tokenResponse.data.token);
            localStorage.setItem('sso', 'false');

            const userResponse = await axios.get('/api/me', {
                headers: { Authorization: `Bearer ${tokenResponse.data.token}` },
            });

            if (userResponse.status !== 200) {
                throw redirect('/login');
            }

            if (userResponse.data.groupement?.id === 1) {
                navigate('/dashboard');
            } else {
                navigate('/dashboard_admin');
            }
        } catch (error: any) {
            if (error.response?.status === 401) {
                setErrorMessage("Nom d'utilisateur ou mot de passe incorrect.");
            }
            console.error(error);
            setErrorMessage("Une erreur s'est produite, veuillez réessayer.");
        }
    };

    return (
        <>
            <form onSubmit={submitHandler} className="w-full max-w-[330px] p-[15px] mx-auto">
                <h1 className="text-super-heavy font-heavy">Se connecter</h1>
                <div className="p-[10px] text-medium h-auto">
                    <label htmlFor="login">Identifiant</label>
                    <input
                        type="email"
                        name="username"
                        className="block w-full leading-[1.5] bg-white rounded border border-[#ced4da]"
                        placeholder=" "
                        value={credentials.username}
                        onChange={onChange}
                    />
                </div>
                <div className="p-[10px] text-medium h-auto">
                    <label htmlFor="password">Mot de passe</label>
                    <input
                        type="password"
                        name="password"
                        className="block w-full leading-[1.5] bg-white rounded border border-[#ced4da]"
                        placeholder=" "
                        value={credentials.password}
                        onChange={onChange}
                    />
                </div>
                {errorMessage && <p className="warning-login">{errorMessage}</p>}
                <div className="p-[10px] text-medium h-auto">
                    <button className="block text-black px-4 py-2 text-medium leading-[1.5] rounded-[1.5rem] w-fit font-medium border border-primary bg-primary items-center content-center justify-center flex-row p-[10px] ">
                        Connexion
                    </button>
                </div>
            </form>
        </>
    );
};
